import {SEARCH_TERM_CAROUSEL_RESULTS_MIN} from '../../../utils/carouselLogUtils';

const getShowDestinationCarousel = (
    isLoadingOrRedirecting,
    typeaheadSuggestion,
    pageCount,
    resultCount,
    discoveryXploreFeeds,
    showDestinationRecommendations
) => {
    return (
        !isLoadingOrRedirecting &&
        !!(
            typeaheadSuggestion &&
            pageCount &&
            pageCount > 0 &&
            resultCount &&
            resultCount >= SEARCH_TERM_CAROUSEL_RESULTS_MIN &&
            discoveryXploreFeeds &&
            discoveryXploreFeeds.results.length > 0 &&
            showDestinationRecommendations
        )
    );
};

const getShowFlexibleDatesContainer = (
    isDatelessSearch,
    isSubsequentFlexDatesView,
    resultCount,
    percentBooked
) => {
    return (
        !isDatelessSearch &&
        !!(
            isSubsequentFlexDatesView ||
            (resultCount &&
                resultCount !== 0 &&
                resultCount <= 50 &&
                percentBooked &&
                percentBooked.currentPercentBooked &&
                percentBooked.currentPercentBooked >= 0.5)
        )
    );
};

export {getShowDestinationCarousel, getShowFlexibleDatesContainer};
